module.exports = __webpack_public_path__ + "static/img/api_04.3fc952af.svg";